import { Button, Col, DatePicker, FormInstance, Input, InputNumber, Row, Select, Form, message, Radio } from "antd";
import FormItem from "antd/lib/form/FormItem";
import { FC, useCallback, useContext, useEffect, useState } from "react";
import { CreateDrawRequest, CreateDrawRequestPayment, DrawRequest, PaymentMethod } from "../../../../types/draw-request";
import { useMsal } from "@azure/msal-react";
import { DataContext } from "../../../../contexts/DataContext";
import moment from "moment";
import { useNavigate, useParams } from "react-router";
import Holidays from "date-holidays";
import { federalBankHolyDays } from "../../../DrawRequests/data/holydays";
import { drawRequestsService } from "../../../../services/draw-request";
import { getDueDateForCheck } from "../../../../helpers/getDueDateForCheck";
import { disabledHolyAndWeekendDate } from "../../../../helpers/getDisabledDates";

interface Props {
  form: FormInstance<CreateDrawRequest>;
  form2: FormInstance<CreateDrawRequestPayment>;
  setStep: React.Dispatch<React.SetStateAction<1 | 2 | 3>>;
  paymentMethod?: number;
  isEdit?: boolean;
  isCopy?: boolean;
  isLoading?: boolean;
  setIsLoading: React.Dispatch<React.SetStateAction<boolean>>;
  handleCancel: () => void;
  createdDrawRequest: DrawRequest | undefined;
  setCreatedDrawRequest: React.Dispatch<React.SetStateAction<DrawRequest | undefined>>;
  isDistribution: boolean;
  setIsDistribution: React.Dispatch<React.SetStateAction<boolean>>;
}

/**========================================================================
 *                          external const here
 *========================================================================**/

/*============================ END OF SECTION ============================*/

/**========================================================================
 *                           external methods here
 *========================================================================**/

/*============================ END OF SECTION ============================*/

export const FirstForm: FC<Props> = ({
  form,
  form2,
  setStep,
  isEdit,
  isCopy,
  isLoading,
  setIsLoading,
  handleCancel,
  createdDrawRequest,
  setCreatedDrawRequest,
  isDistribution,
  setIsDistribution
}) => {
  /**========================================================================
   *                           Hooks here
   *========================================================================**/
  const navigate = useNavigate();
  const { accounts } = useMsal();
  const {
    projects,
    areProjectsLoading,
    codes,
    loading,
    drawRequestContext: {
      drawRequestData: { paymentMethods },
      isDrawRequestDataFetching,
      isDrawRequestDataLoading
    }
  } = useContext(DataContext);
  const accountName = accounts && accounts.length ? `${accounts[0].name}` : "";
  const [dueDate, setDueDate] = useState<moment.Moment>(moment());
  const [tenDueDate, setTenDueDate] = useState<moment.Moment>(moment());
  const [ruleDueDate, setRuleDueDate] = useState<moment.Moment>(moment());

  const [paymentType, setPaymentType] = useState<number | undefined>(undefined);
  const [saveAndExit, setSaveAndExit] = useState<boolean>(true);
  const { id } = useParams();

  const isWire = () => {
    return paymentType === 1 || paymentType === 2;
  };

  const drawType = Form.useWatch("drawType", form);
  const paymentMethod = Form.useWatch("paymentMethod", form);

  useEffect(() => {
    if (drawType === "distribution" || paymentMethod === 5) {
      console.log("no rules");
      return;
    }

    let dueDateAux = moment();
    const hd = new Holidays("US");
    const holidays = hd
      .getHolidays(dueDateAux.year())
      .filter((holy) => federalBankHolyDays.includes(holy.name))
      .map((holy: any) => {
        return holy.date.split(" ")[0];
      });
    const holidaysNextYear = hd
      .getHolidays(dueDateAux.year() + 1)
      .filter((holy) => federalBankHolyDays.includes(holy.name))
      .map((holy: any) => {
        return holy.date.split(" ")[0];
      });
    let totalDays = 0;

    while (totalDays !== 10) {
      const formattedDate = dueDateAux.format("YYYY-MM-DD");
      // console.log("loop ", totalDays, dueDateAux);

      if (
        dueDateAux.day() !== 0 &&
        dueDateAux.day() !== 6 &&
        !holidays.includes(formattedDate) &&
        !holidaysNextYear.includes(formattedDate)
      ) {
        totalDays++;
      }

      dueDateAux.add(1, "day");
    }
    let formattedDate = dueDateAux.format("YYYY-MM-DD");
    while (
      dueDateAux.day() === 0 ||
      dueDateAux.day() === 6 ||
      holidays.includes(formattedDate) ||
      holidaysNextYear.includes(formattedDate)
    ) {
      dueDateAux.add(1, "day");
      formattedDate = dueDateAux.format("YYYY-MM-DD");
    }

    setTenDueDate(dueDateAux);
  }, []);

  useEffect(() => {
    if (form.getFieldValue("paymentMethod")) setPaymentType(form.getFieldValue("paymentMethod"));
  }, [isLoading]);

  // useEffect(() => {
  //   setIsDistribution(form.getFieldValue("drawType") === "distribution");
  // }, [form]);

  /*============================ END OF SECTION ============================*/

  /**========================================================================
   *                           Const here
   *========================================================================**/

  /*============================ END OF SECTION ============================*/

  /**========================================================================
   *                           Methods here
   *========================================================================**/

  // const handleFirstCreation = async (saveAndExit: boolean) => {
  //   try {
  //     if (!createdDrawRequest) {
  //       const resp = await drawRequestsService.createNewDrawRequest(form.getFieldsValue());
  //       setCreatedDrawRequest(resp);
  //       message.success({ content: "Draw Request Saved" });
  //     } else {
  //       const resp = await drawRequestsService.editDrawRequest(createdDrawRequest.id, form.getFieldsValue());
  //       setCreatedDrawRequest(resp);
  //       message.info({ content: "Draw Request Updated" });
  //     }
  //     if (!saveAndExit) setStep(2);
  //     else handleCancel();
  //   } catch (error) {
  //     message.error({ content: "Ups: Something was wrong, please try again later" });
  //   }
  // };

  const handleSaveAndExit = async () => {
    try {
      if ((isEdit && Number(id) && !isCopy) || createdDrawRequest?.id) {
        const idAux = Number(id) || createdDrawRequest?.id;
        if (!idAux) throw new Error("not id found");

        const resp = await drawRequestsService.editDrawRequest(idAux, form.getFieldsValue());
        message.success(`Draw Request Edited`);
        return resp;
      } else {
        const resp = await drawRequestsService.createNewDrawRequest(form.getFieldsValue());
        message.success(`Draw Request Created`);
        return resp;
      }
    } catch (error) {
      message.error(
        `Ups: something was wrong ${isEdit ? "updating" : "creating"} the draw request, please try again later or contact the support`
      );
      return undefined;
    }
  };

  const handleFirstForm = (saveAndExit: boolean) => async () => {
    setIsLoading(true);
    const resp = await handleSaveAndExit();
    setCreatedDrawRequest(resp);
    if (saveAndExit) handleCancel();
    else setStep(2);

    setIsLoading(false);
  };

  const onPaymentMethodChanged = (value: number) => {
    if (drawType === "distribution" || paymentMethod === 5) {
      console.log("no rules");
      return;
    }

    if (((form.getFieldValue("drawType") || "") as string).toLowerCase() === "distribution") {
      return;
    }
    if (value == 1 || value == 2) {
      setRuleDueDate(tenDueDate);
      setDueDate(tenDueDate);
      form.setFieldsValue({ dueDate: tenDueDate });
    } else {
      const dateForCheck = getDueDateForCheck();

      setRuleDueDate(dateForCheck);
      setDueDate(dateForCheck);

      form.setFieldsValue({ dueDate: dateForCheck });
    }

    form.setFieldsValue({
      paymentMethod: paymentMethods?.find((item) => item.id === value)?.id,
      JvDepositGlCodeID: undefined,
      JvWithdrawalGlCodeID: undefined,
      MainCmsGlCodeID: undefined
    });

    form2.setFieldsValue({
      abbaOrSwiftAccountNo: undefined,
      accountNo: undefined
    });

    setPaymentType(value);
  };

  useEffect(() => {
    const payment = form.getFieldValue("paymentMethod");
    if (!payment) return;
    onPaymentMethodChanged(payment);
  }, [paymentMethod]);

  const onAmountChange = () => {
    form2.setFieldsValue({
      expatInChargeId: undefined,
      expatOfficerId: undefined,
      agreementFile: undefined
    });
  };

  const onDrawRequestType = (value: string) => {
    setIsDistribution(value === "distribution");
    form.setFieldsValue({
      paymentMethod: undefined
    });
  };

  // const isDistribution = useCallback(() => {
  //   return form.getFieldValue("drawType") === "distribution";
  // }, [form]);

  /*============================ END OF SECTION ============================*/

  return (
    <>
      {/* /========================================================================  HTML here
    ========================================================================*/}
      <>
        <Row>
          <Col>
            <h2>Step 1: Application page</h2>
          </Col>
        </Row>
        <hr style={{ marginBottom: "8px" }} />

        <div className="form-container-centered">
          <Row style={{ width: "80%" }}>
            <Col span={24}>
              <Form
                scrollToFirstError={{ behavior: "auto" }}
                name="draw-request-form"
                form={form}
                initialValues={{
                  initiator: accountName,
                  amount: 0,
                  drawNumber: "",
                  projectName: "",
                  drawType: "payment/capital call",
                  controlNumber: "0"
                }}
                onFinish={handleFirstForm(saveAndExit)}
              >
                {" "}
                <FormItem
                  labelCol={{ span: 4 }}
                  labelAlign="left"
                  label="Draw Request Type"
                  style={{ margin: "0px" }}
                  name="drawType"
                  rules={[{ required: true, message: "Draw Request Type is required" }]}
                >
                  <Radio.Group
                    style={{ display: "flex", flexDirection: "column" }}
                    value="payment/capital call"
                    onChange={({ target: { value } }) => {
                      onDrawRequestType(value);
                    }}
                  >
                    <Row>
                      <Col span={24} style={{ marginBottom: "10px" }}>
                        <Radio
                          style={{
                            marginRight: "0px"
                          }}
                          value="payment/capital call"
                        >
                          Payment / Capital Call
                        </Radio>
                        <Radio value="distribution">Distribution</Radio>
                      </Col>
                    </Row>
                  </Radio.Group>
                </FormItem>
                <FormItem
                  label="Select Payment Method"
                  labelCol={{ span: 4 }}
                  labelAlign="left"
                  name="paymentMethod"
                  rules={[{ required: true, message: "payment method is required" }]}
                >
                  <Select
                    loading={isDrawRequestDataFetching || isDrawRequestDataLoading}
                    style={{ width: "100%" }}
                    showSearch={true}
                    options={paymentMethods?.map((item) => ({ label: item.name, value: item.id }))}
                    onChange={(value: number) => {
                      onPaymentMethodChanged(value);
                    }}
                    filterOption={(input, option) => (option?.label ?? "").toLowerCase().includes(input.toLowerCase())}
                  />
                </FormItem>
                <FormItem
                  labelCol={{ span: 4 }}
                  labelAlign="left"
                  label="Initiator"
                  name="initiator"
                  rules={[{ required: true, message: "initiator is required" }]}
                >
                  <Input disabled />
                </FormItem>
                <FormItem
                  labelCol={{ span: 4 }}
                  labelAlign="left"
                  label="Project"
                  name="projectID"
                  rules={[{ required: true, message: "project is required" }]}
                >
                  <Select
                    style={{ width: "100%" }}
                    showSearch={true}
                    options={projects.filter((item) => item.active).map((item) => ({ label: item.name, value: item.id }))}
                    loading={areProjectsLoading}
                    onChange={(value) => form.setFieldsValue({ accountID: projects.filter((item) => item.id === value)[0].accountID })}
                    filterOption={(input, option) => (option?.label ?? "").toLowerCase().includes(input.toLowerCase())}
                  />
                </FormItem>
                {/* <FormItem labelCol={{ span: 4 }} labelAlign="left" name="accountID" noStyle></FormItem> */}
                <FormItem
                  labelCol={{ span: 4 }}
                  labelAlign="left"
                  label="Draw No. / Invoice No."
                  name="drawNumber"
                  rules={[{ required: true, message: "Draw No. / Invoice No. is required" }]}
                >
                  <Input />
                </FormItem>
                <FormItem
                  labelCol={{ span: 4 }}
                  labelAlign="left"
                  label="Amount"
                  name="amount"
                  rules={[{ required: true, message: "amount is required" }]}
                >
                  <InputNumber onChange={() => onAmountChange()} addonBefore="$" style={{ width: "100%" }} inputMode="decimal" />
                </FormItem>
                <FormItem
                  labelCol={{ span: 4 }}
                  labelAlign="left"
                  label="Due Date"
                  name="dueDate"
                  rules={[{ required: true, message: "due date is required" }]}
                >
                  <DatePicker
                    disabled={drawType !== "distribution" && !isWire() && paymentType !== 5}
                    format="MM/DD/YYYY"
                    style={{ width: "100%" }}
                    disabledDate={(currentDate) => {
                      const holy = disabledHolyAndWeekendDate(currentDate);

                      if (`${paymentType}` === "5") return currentDate.isBefore(moment().subtract(1, "month").startOf("month")) || holy;
                      return currentDate.isBefore(ruleDueDate) || holy;
                    }}
                  />
                </FormItem>
                <FormItem
                  labelCol={{ span: 4 }}
                  labelAlign="left"
                  label="Invoice Date"
                  name="invoiceDate"
                  rules={[{ required: true, message: "invoiceDate date is required" }]}
                >
                  <DatePicker format="MM/DD/YYYY" style={{ width: "100%" }} />
                </FormItem>
                <FormItem labelCol={{ span: 4 }} labelAlign="left" label="Control Number" name="controlNumber">
                  <Input disabled />
                </FormItem>
                {isWire() && (
                  <>
                    <FormItem
                      labelCol={{ span: 4 }}
                      labelAlign="left"
                      label="GL Code"
                      name="MainCmsGlCodeID"
                      rules={[{ required: true, message: "gl code is required" }]}
                    >
                      <Select
                        style={{ width: "100%" }}
                        showSearch={true}
                        options={[...codes.map((item) => ({ label: `${item.gl_code} (${item.account_name})`, value: item.id }))]}
                        loading={loading}
                        onChange={(value) => form.setFieldsValue({ MainCmsGlCodeID: value })}
                        filterOption={(input, option) => (option?.label ?? "").toLowerCase().includes(input.toLowerCase())}
                      />
                    </FormItem>

                    {/* <FormItem
                      labelCol={{ span: 4 }}
                      labelAlign="left"
                      label="JV Deposit GL Code"
                      name="JvDepositGlCodeID"
                      rules={[{ required: true, message: "jv deposit gl code is required" }]}
                    >
                      <Select
                        style={{ width: "100%" }}
                        showSearch={true}
                        options={codes.map((item) => ({ label: `${item.gl_code} (${item.account_name})`, value: item.id }))}
                        loading={loading}
                        onChange={(value) => form.setFieldsValue({ JvDepositGlCodeID: value })}
                        filterOption={(input, option) => (option?.label ?? "").toLowerCase().includes(input.toLowerCase())}
                      />
                    </FormItem>
                    <FormItem
                      labelCol={{ span: 4 }}
                      labelAlign="left"
                      label="JV Withdrawal GL Code"
                      name="JvWithdrawalGlCodeID"
                      rules={[{ required: true, message: "jv withdrawal gl code" }]}
                    >
                      <Select
                        style={{ width: "100%" }}
                        showSearch={true}
                        options={codes.map((item) => ({ label: `${item.gl_code} (${item.account_name})`, value: item.id }))}
                        loading={loading}
                        onChange={(value) => form.setFieldsValue({ JvWithdrawalGlCodeID: value })}
                        filterOption={(input, option) => (option?.label ?? "").toLowerCase().includes(input.toLowerCase())}
                        // filterSort={(optionA, optionB) =>
                        //   (optionA?.label ?? '').toLowerCase().localeCompare((optionB?.label ?? '').toLowerCase())
                      />
                    </FormItem> */}
                  </>
                )}
                <Row>
                  <Col style={{ width: "100%", display: "flex", justifyContent: "space-between" }}>
                    <Button key="cancel" onClick={() => handleCancel()} danger type="primary">
                      Close
                    </Button>
                    <div>
                      <Button
                        key="submit"
                        type="primary"
                        htmlType="submit"
                        style={{ marginRight: 5 }}
                        onClick={() => setSaveAndExit(true)}
                        // disabled={form.getFieldsError().length > 0}
                      >
                        {(!isEdit || isCopy) && <> {`  ${isDistribution ? "Create" : "Create & Exit"} `} </>}

                        {isEdit && !isCopy && <> {`  ${isDistribution ? "Save" : "Save & Exit"} `} </>}
                      </Button>

                      {!isDistribution && (
                        <Button
                          key="submit2"
                          type="primary"
                          htmlType="submit"
                          onClick={() => setSaveAndExit(false)}
                          // disabled={form.getFieldsError().length > 0}
                        >
                          Save & Continue
                        </Button>
                      )}
                    </div>
                    {/* errors:
              {JSON.stringify(form.getFieldsError())} */}
                  </Col>
                </Row>
              </Form>
            </Col>
          </Row>
        </div>
      </>

      {/*============================ END OF SECTION ============================*/}
    </>
  );
};
